"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawPatternedShape = exports.generatePatternData = exports.drawSegment = void 0;
var dom = __importStar(require("./domElements.ts"));
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var colorUtils_ts_1 = require("./colorUtils.ts");
function drawSegment(gridX, gridY) {
    dom.ctx.fillRect(gridX * state.calculatedSegmentSize, gridY * state.calculatedSegmentSize, state.calculatedSegmentSize, state.calculatedSegmentSize);
}
exports.drawSegment = drawSegment;
function _generatePixelStandardPattern(patternDim, maxFill) {
    var newPattern = [];
    for (var r = 0; r < patternDim; r++) {
        var row = [];
        for (var c = 0; c < patternDim; c++) {
            var isVisible = Math.random() < maxFill + 0.1; // Add a slight bias towards filling
            var stampData = null;
            if (isVisible && state.loadedImage && Math.random() < state.stampChance) {
                var segmentSize = state.calculatedSegmentSize;
                if (state.loadedImage.naturalWidth >= segmentSize &&
                    state.loadedImage.naturalHeight >= segmentSize) {
                    var sx = Math.floor(Math.random() * (state.loadedImage.naturalWidth - segmentSize + 1));
                    var sy = Math.floor(Math.random() * (state.loadedImage.naturalHeight - segmentSize + 1));
                    stampData = { sx: sx, sy: sy, sWidth: segmentSize, sHeight: segmentSize };
                }
            }
            row.push({ visible: isVisible, color: null, stampSource: stampData });
        }
        newPattern.push(row);
    }
    // Ensure center segment is visible for odd dimensions
    if (patternDim % 2 === 1) {
        var centerIndex = Math.floor(patternDim / 2);
        if (!newPattern[centerIndex][centerIndex].visible) {
            newPattern[centerIndex][centerIndex].visible = true;
            if (!newPattern[centerIndex][centerIndex].stampSource &&
                state.loadedImage &&
                Math.random() < state.stampChance) {
                var segmentSize = state.calculatedSegmentSize;
                if (state.loadedImage.naturalWidth >= segmentSize &&
                    state.loadedImage.naturalHeight >= segmentSize) {
                    var sx = Math.floor(Math.random() * (state.loadedImage.naturalWidth - segmentSize + 1));
                    var sy = Math.floor(Math.random() * (state.loadedImage.naturalHeight - segmentSize + 1));
                    newPattern[centerIndex][centerIndex].stampSource = {
                        sx: sx,
                        sy: sy,
                        sWidth: segmentSize,
                        sHeight: segmentSize
                    };
                }
            }
        }
    }
    return newPattern;
}
function generatePatternData(patternDim, maxFill, patternStyle, _proximityInfluence, _effectivePalette) {
    if (patternStyle === "pixelStandard") {
        var pxs = _generatePixelStandardPattern(patternDim, maxFill);
        var totalVisibleStd = pxs.flat().filter(function (s) { return s.visible; }).length;
        var maxAllowedVisibleStd = Math.floor(patternDim * patternDim * maxFill);
        var attemptsStd = 0;
        while (totalVisibleStd > maxAllowedVisibleStd &&
            attemptsStd < patternDim * patternDim * 2) {
            var randR = Math.floor(Math.random() * patternDim);
            var randC = Math.floor(Math.random() * patternDim);
            var isCenterOdd = patternDim % 2 === 1 &&
                randR === Math.floor(patternDim / 2) &&
                randC === Math.floor(patternDim / 2);
            if (pxs[randR][randC].visible &&
                (!isCenterOdd || totalVisibleStd > maxAllowedVisibleStd + 1)) {
                pxs[randR][randC].visible = false;
                if (pxs[randR][randC].stampSource)
                    pxs[randR][randC].stampSource = null;
                totalVisibleStd--;
            }
            attemptsStd++;
        }
        return pxs;
    }
    console.warn("Unsupported pattern style requested: ".concat(patternStyle, ". Defaulting to null."));
    return null;
}
exports.generatePatternData = generatePatternData;
function drawPatternedShape(centerX_segment, centerY_segment, currentMaxRingToDraw, patternSegments, // Not used directly, effectToUpdate or permanentFlowerData is primary
effectToUpdate, permanentFlowerData) {
    var _a, _b;
    if (!(effectToUpdate === null || effectToUpdate === void 0 ? void 0 : effectToUpdate.patternSegments) && !(permanentFlowerData === null || permanentFlowerData === void 0 ? void 0 : permanentFlowerData.patternSegments))
        return;
    var currentPatternSegments = (_a = effectToUpdate === null || effectToUpdate === void 0 ? void 0 : effectToUpdate.patternSegments) !== null && _a !== void 0 ? _a : permanentFlowerData === null || permanentFlowerData === void 0 ? void 0 : permanentFlowerData.patternSegments;
    if (!currentPatternSegments)
        return;
    var patternHeight = currentPatternSegments.length;
    var patternWidth = patternHeight > 0 ? currentPatternSegments[0].length : 0;
    if (patternWidth === 0 || patternHeight === 0)
        return;
    var flowerData = effectToUpdate || permanentFlowerData;
    var usesSpecialPalette = !!(flowerData === null || flowerData === void 0 ? void 0 : flowerData.effectivePalette);
    var attemptBaseLayerRestore = usesSpecialPalette && !(flowerData === null || flowerData === void 0 ? void 0 : flowerData.isUserClickFlower) && Math.random() < 0.9;
    // Derive flowerWorkingPalette for this specific flower effect
    var flowerWorkingPalette;
    if (effectToUpdate) {
        var proximityInfluence = effectToUpdate.isMockUserFlower
            ? 0.75
            : (_b = effectToUpdate.flowerProximityInfluence) !== null && _b !== void 0 ? _b : 0.5;
        flowerWorkingPalette = effectToUpdate.effectivePalette
            ? __spreadArray([], effectToUpdate.effectivePalette, true) : __spreadArray([], state.currentColorPalette, true);
        if (flowerWorkingPalette.length > 1) {
            var numColorsToUse = Math.round(flowerWorkingPalette.length * proximityInfluence);
            numColorsToUse = Math.max(config.MIN_COLOR_VARIETY_PROXIMITY, Math.min(flowerWorkingPalette.length, numColorsToUse));
            if (numColorsToUse < flowerWorkingPalette.length) {
                // Shuffle and slice to get the desired number of colors
                var shuffled = __spreadArray([], flowerWorkingPalette, true).sort(function () { return 0.5 - Math.random(); });
                flowerWorkingPalette = shuffled.slice(0, numColorsToUse);
            }
        }
        if (flowerWorkingPalette.length === 0)
            flowerWorkingPalette.push("#FFFFFF"); // Fallback
    }
    else if (permanentFlowerData) {
        // For permanent flowers, the palette should ideally be baked in or derived similarly if needed
        // For now, assume colors are baked or use a default. This path is less critical as colors are final.
        flowerWorkingPalette = permanentFlowerData.effectivePalette
            ? __spreadArray([], permanentFlowerData.effectivePalette, true) : __spreadArray([], state.currentColorPalette, true);
        if (flowerWorkingPalette.length === 0)
            flowerWorkingPalette.push("#FFFFFF");
    }
    else {
        flowerWorkingPalette = __spreadArray([], state.currentColorPalette, true); // Should not happen
        if (flowerWorkingPalette.length === 0)
            flowerWorkingPalette.push("#FFFFFF");
    }
    for (var ring = 0; ring <= currentMaxRingToDraw; ring++) {
        for (var dxOffset = -ring; dxOffset <= ring; dxOffset++) {
            for (var dyOffset = -ring; dyOffset <= ring; dyOffset++) {
                if (Math.max(Math.abs(dxOffset), Math.abs(dyOffset)) !== ring) {
                    continue;
                }
                var segmentGridAbsoluteX = centerX_segment + dxOffset;
                var segmentGridAbsoluteY = centerY_segment + dyOffset;
                var patternX = Math.abs(dxOffset);
                var patternY = Math.abs(dyOffset);
                var segmentDefinition = null;
                if (patternX < patternWidth && patternY < patternHeight) {
                    segmentDefinition = currentPatternSegments[patternY][patternX];
                }
                if (segmentDefinition && segmentDefinition.visible) {
                    var finalSegmentColor = segmentDefinition.color;
                    var segmentWasStamped = false;
                    var segmentRestoredFromBase = false;
                    var drawPixelX = segmentGridAbsoluteX * state.calculatedSegmentSize;
                    var drawPixelY = segmentGridAbsoluteY * state.calculatedSegmentSize;
                    if (attemptBaseLayerRestore) {
                        if (state.baseLayerCanvas && state.baseLayerCtx) {
                            try {
                                dom.ctx.drawImage(state.baseLayerCanvas, drawPixelX, drawPixelY, state.calculatedSegmentSize, state.calculatedSegmentSize, drawPixelX, drawPixelY, state.calculatedSegmentSize, state.calculatedSegmentSize);
                                segmentRestoredFromBase = true;
                            }
                            catch (e) {
                                console.warn("Error restoring segment from base layer:", e);
                            }
                        }
                    }
                    if (!segmentRestoredFromBase &&
                        segmentDefinition.stampSource &&
                        state.loadedImage) {
                        if (state.loadedImage.naturalWidth >=
                            segmentDefinition.stampSource.sWidth &&
                            state.loadedImage.naturalHeight >=
                                segmentDefinition.stampSource.sHeight) {
                            try {
                                dom.ctx.drawImage(state.loadedImage, segmentDefinition.stampSource.sx, segmentDefinition.stampSource.sy, segmentDefinition.stampSource.sWidth, segmentDefinition.stampSource.sHeight, drawPixelX, drawPixelY, state.calculatedSegmentSize, state.calculatedSegmentSize);
                                segmentWasStamped = true;
                            }
                            catch (e) {
                                console.warn("Error drawing stamp:", e);
                            }
                        }
                    }
                    if (!segmentRestoredFromBase && !segmentWasStamped) {
                        if (effectToUpdate) {
                            var activeSegment = effectToUpdate.patternSegments[patternY][patternX];
                            if (activeSegment.color === null) {
                                // Color not yet assigned (e.g. by symmetry override)
                                var chosenColor = null;
                                if (!state.enableSymmetricalSpecialColor) {
                                    // If symmetry is OFF, decide per segment
                                    chosenColor = (0, colorUtils_ts_1.determineSpecialColorForSegment)(flowerWorkingPalette, effectToUpdate.isUserClickFlower, effectToUpdate.isMockUserFlower, !!effectToUpdate.effectivePalette);
                                }
                                if (chosenColor) {
                                    activeSegment.color = chosenColor;
                                }
                                else {
                                    // Pick from the derived flowerWorkingPalette
                                    activeSegment.color =
                                        flowerWorkingPalette[Math.floor(Math.random() * flowerWorkingPalette.length)];
                                }
                            }
                            finalSegmentColor = activeSegment.color;
                        }
                        else if (permanentFlowerData) {
                            // For permanent flowers, color should already be baked in segmentDefinition.color
                            finalSegmentColor = segmentDefinition.color;
                            if (finalSegmentColor === null) {
                                // Should not happen if baking is correct
                                console.warn("Permanent flower segment ".concat(permanentFlowerData.id, " at ").concat(patternX, ",").concat(patternY, " has no baked color."));
                                finalSegmentColor =
                                    flowerWorkingPalette[Math.floor(Math.random() * flowerWorkingPalette.length)];
                            }
                        }
                        if (finalSegmentColor) {
                            dom.ctx.fillStyle = finalSegmentColor;
                            drawSegment(segmentGridAbsoluteX, segmentGridAbsoluteY);
                        }
                    }
                }
            }
        }
    }
}
exports.drawPatternedShape = drawPatternedShape;
